// This initializer exists only to make sure that the following
// imports happen before the app boots.
import 'ember-concurrency';
export default {
  name: 'ember-concurrency',
  initialize: function () {}
};